export default __webpack_public_path__ + "static/escalator_b.f80e48c2711e7073dbf7be62b1e5c325.svg";